import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id: sessionId });
        login(res.data.token, res.data.user);
        window.history.replaceState(null, "", "/portal");
        navigate("/portal", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <span className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground animate-pulse">
        Signing you in…
      </span>
    </div>
  );
}
